import { awaitImage } from "./awaitImage"

export const updateCanvas = async (baseImage, customImage) => {
  const canvas = document.createElement("canvas")
  const renderedBaseImage = await awaitImage(baseImage)
  canvas.width = renderedBaseImage.width
  canvas.height = renderedBaseImage.height
  const ctx = canvas.getContext("2d")
  ctx.drawImage(renderedBaseImage, 0, 0, canvas.width, canvas.height)
  if (customImage) {
    const renderedCustomImage = await awaitImage(customImage)
    const customImageRatio =
      renderedCustomImage.width / renderedCustomImage.height
    const margin = renderedBaseImage.width * 0.32
    if (customImageRatio >= 1) {
      // ctx.fillRect(
      //   margin,
      //   margin,
      //   canvas.width - margin * 2,
      //   canvas.height - margin * 2
      // )
      ctx.drawImage(
        renderedCustomImage,
        margin,
        margin,
        canvas.width - margin * 2,
        (canvas.width - margin * 2) / customImageRatio
      )
    } else {
      const diff =
        canvas.width -
        margin * 2 -
        (canvas.width - margin * 2) * customImageRatio
      ctx.drawImage(
        renderedCustomImage,
        margin + diff / 2,
        margin,
        (canvas.width - margin * 2) * customImageRatio,
        canvas.width - margin * 2
      )
    }
  } else {
    //TODO PLACEHOLDER TEXT
  }
  const dataUrl = canvas.toDataURL("image/png")
  return dataUrl
}
